module.exports = __webpack_public_path__ + "img/after-sale-poster.c629feab.png";